import { cloneDeep, findIndex } from "lodash";
import {
  CREATE_GRADEBOOK_GRADE_SUCCESS,
  DELETE_GRADEBOOK_GRADE_SUCCESS,
  GET_GRADEBOOK_GRADE_SUCCESS,
  UPDATE_GRADEBOOK_GRADE_SUCCESS,
} from "../constants";

export const initialState = {
  gradebookGrade: undefined,
};

export const gradebookGradeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GRADEBOOK_GRADE_SUCCESS: {
      return {
        ...state,
        gradebookGrade: action.payload,
      };
    }
    case UPDATE_GRADEBOOK_GRADE_SUCCESS: {
      const tempcategories = cloneDeep(state.gradebookGrade);
      const index = findIndex(
        tempcategories.data,
        (obj) => obj._id === action.payload._id
      );
      

      
      if (index !== -1) {
        tempcategories.data[index] = action.payload;
      }
      
      return {
        ...state,
        gradebookGrade: tempcategories,
      };
    }
    case CREATE_GRADEBOOK_GRADE_SUCCESS: {
      return {
        ...state,
        gradebookGrade: action.payload,
      };
    }
    case DELETE_GRADEBOOK_GRADE_SUCCESS: {
      return {
        ...state,
        gradebookGrade: action.payload,
      };
    }

    default:
      return state;
  }
};
